<astrea-internal-banner
    title="{{ 'register.title' | translate }}"
></astrea-internal-banner>

<div class="d-flex j-c-around a-i-center content-height p-sm-4 p-2">

    <div class="hide-mobile background-left">
        <img class="img-responsive" src="/assets/images/illustrations/Illustration-register-1.png" alt="Joven muchacho trabajando con una computadora portatil.">
    </div>

    <div class="astrea-box astrea-register">

        <mat-card class="p-2">
            <mat-card-title>
                <div class="astrea-subtitle">
                    <h2 class="register-title">{{ 'register.title' | translate }}</h2>
                </div>
            </mat-card-title>
            <mat-card-content>
                <form [formGroup]="formRegister" (ngSubmit)="registerUser()">

                    <mat-form-field appearance="fill">
                        <mat-label>{{ 'profile.personal.name' | translate }}</mat-label>
                        <input type="text" matInput formControlName="name">
                        <mat-icon matSuffix>account_circle</mat-icon>
                        <mat-error>{{ 'profile.personal.name_err' | translate }}</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill">
                        <mat-label>{{ 'login.email' | translate }}</mat-label>
                        <input type="email" matInput formControlName="user">
                        <mat-icon matSuffix>email</mat-icon>
                        <mat-error>{{ 'login.email_err' | translate }}</mat-error>
                    </mat-form-field>

                    <mat-form-field class="astrea-error-match" appearance="fill">
                        <mat-label>{{ 'register.repeat_email' | translate }}</mat-label>
                        <input type="email" matInput formControlName="confirmUser">
                        <mat-icon matSuffix>email</mat-icon>
                        <div *ngIf="formRegister.get('confirmUser')!.touched && formRegister.hasError('match_user')">
                            <mat-error class="astrea-match-pass">{{ 'register.err_email_match' | translate }} <br></mat-error>
                        </div>
                    </mat-form-field>

                    <mat-form-field appearance="fill">
                        <mat-label>{{ 'login.password' | translate }}</mat-label>
                        <input [type]="hide ? 'password' : 'text'" matInput formControlName="newPass">
                        <button type="button" mat-icon-button matSuffix (click)="changeTypePass()" attr.aria-label="{{ 'login.see_password' | translate }}" [attr.aria-pressed]="hide" tabindex="-1">
                            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                        <mat-error>{{ 'register.pass_err' | translate }}</mat-error>
                    </mat-form-field>

                    <mat-form-field class="astrea-error-match" appearance="fill">
                        <mat-label>{{ 'register.repeat_pass' | translate }}</mat-label>
                        <input [type]="hide ? 'password' : 'text'" matInput formControlName="confirmPass">
                        <button type="button" mat-icon-button matSuffix (click)="changeTypePass()" attr.aria-label="{{ 'login.see_password' | translate }}" [attr.aria-pressed]="hide" tabindex="-1">
                            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                        <div *ngIf="formRegister.get('confirmPass')!.touched && formRegister.hasError('match_password')">
                            <mat-error class="astrea-match-pass">{{ 'change_pass.error_match' | translate }} <br></mat-error>
                        </div>
                    </mat-form-field>

                    <div>
                        <mat-checkbox class="my-2" formControlName="terms" [required]="true">
                            {{ 'register.accept' | translate }} <a href="/terms" target="_blank" title="{{ 'terms.title' | translate }}">{{ 'terms.title' | translate }}</a>
                        </mat-checkbox>
                        <mat-error *ngIf="submitted && !formRegister.get('terms')!.value">
                            <small>{{ 'register.terms_err' | translate }}</small>
                        </mat-error>
                    </div>

                    <button *ngIf="!loading" (click)="registerUser()" class="btn btn-green mt-3 w-100" mat-button>
                        {{ 'register.register_user' | translate }}
                    </button>
                    <button *ngIf="loading" class="btn btn-green mt-3 w-100" mat-button>
                        <astrea-loading></astrea-loading>
                    </button>

                </form>

            </mat-card-content>
            <mat-card-actions class="p-0">
                <a [routerLink]="['/login']" [queryParams]="{ redirect: redirect }" class="login-link b-register p-2" mat-flat-button>
                    <span>
                        {{ 'register.have_account' | translate }}
                    </span>
                </a>
            </mat-card-actions>
        </mat-card>

    </div>

    <div class="hide-mobile background-right">
        <img class="img-responsive" src="/assets/images/illustrations/Illustration-register-2.png" alt="Adolecente leyendo un libro y bebiendo café.">
    </div>

</div>
